
import { defineComponent } from "vue";
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: "BreakdownTableLoading",
  setup() {
    const { t } = useI18n();
    const dataTable = [
      { title: t("dashboard.errorBreakdownTable.service"), row: 3 },
      { title: t("dashboard.errorBreakdownTable.channel"), row: 4 },
      { title: t("dashboard.errorBreakdownTable.shipmentType"), row: 8 },
      { title: t("dashboard.errorBreakdownTable.destinationCity"), row: 10 },
      { title: t("dashboard.errorBreakdownTable.commodity"), row: 10 }
    ];

    return {
      dataTable
    };
  }
});
